module.exports = __webpack_public_path__ + "static/media/list_2.5ac4f02f.svg";